import { render } from "./NestedElement.vue?vue&type=template&id=42df3e0c&scoped=true&ts=true"
import script from "./NestedElement.vue?vue&type=script&lang=ts"
export * from "./NestedElement.vue?vue&type=script&lang=ts"

import "./NestedElement.vue?vue&type=style&index=0&id=42df3e0c&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42df3e0c"]])

export default __exports__